import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { Waveform } from '../components/mockui';

export const CtaBanner = () => (
  <section className="pb-20 pt-4 lg:pb-28" data-testid="cta-section">
    <div className="container-x">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-brand-panel via-brand-panel to-brand-panelDeep px-8 py-16 text-center shadow-lift sm:px-16 lg:py-20">
          <div className="bg-grid pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" />
          <div
            className="pointer-events-none absolute -left-20 -top-20 h-72 w-72 rounded-full opacity-40 blur-3xl"
            style={{ background: 'radial-gradient(closest-side, rgba(245,158,11,0.35), transparent)' }}
            aria-hidden="true"
          />
          <div
            className="pointer-events-none absolute -bottom-24 -right-16 h-80 w-80 rounded-full opacity-30 blur-3xl"
            style={{ background: 'radial-gradient(closest-side, rgba(27,168,224,0.5), transparent)' }}
            aria-hidden="true"
          />

          <div className="relative">
            <Waveform bars={16} className="mx-auto h-8 w-44" tone="bg-brand-honey/80" />
            <h2 className="mx-auto mt-6 max-w-2xl text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
              Ready to Transform Your{' '}
              <span className="bg-gradient-to-r from-brand-honey to-amber-300 bg-clip-text text-transparent">
                Business?
              </span>
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/75">
              Book a demo today and see how CapableBee can turn conversations into leads.
            </p>
            <Link
              to="/contact"
              data-testid="cta-banner-btn"
              className="group mt-9 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-extrabold text-brand-navy shadow-lift transition-all hover:-translate-y-0.5 hover:shadow-2xl"
            >
              Get Started
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
